import { useQuery } from "@tanstack/react-query";

import { clientAnalyticsService } from "@/services/clientAnalyticsService";

export const clientAnalyticsEmbedQueryKey = (website: string) =>
  ["client-analytics", "embed-config", website] as const;

/**
 * Loads the private report-frame configuration for exactly one tenant.
 *
 * The website is part of the cache key and no placeholder data is carried
 * between keys. That makes a tenant switch return to the loading state instead
 * of briefly reusing the previous tenant's bearer URL.
 */
export function useClientAnalyticsEmbed(website: string) {
  return useQuery({
    queryKey: clientAnalyticsEmbedQueryKey(website),
    queryFn: () => clientAnalyticsService.getEmbedConfig(website),
    enabled: Boolean(website),
    placeholderData: undefined,
    // The response contains a revocable bearer URL. Refetch when remounted and
    // discard it as soon as no mounted dashboard needs it.
    staleTime: 0,
    gcTime: 0,
    retry: 1,
  });
}
